import {createContext} from 'react';

/**
 * Roster data shared by the People route's side nav and its child tabs. `null` until the
 * `People` provider mounts.
 */
export interface PeopleContextValue {
  isReady: boolean;
  classroom: unknown;
  invitations: unknown;
  students: unknown;
  teachers: unknown;
  queries: {
    classroom: unknown;
    invitations: unknown;
    students: unknown;
    coteachers: unknown;
  };
  currentTeacherId: string | null | undefined;
}

const PeopleContext = createContext<PeopleContextValue | null>(null);

export default PeopleContext;
